export default __webpack_public_path__ + "static/media/speakerlinks.5482cb89.png";